const DENIED_NAMES_PREFIXES = /^(dr|dra|sr|sra|eng)$/;
const VALID_LETTERS = /^[a-záéíóúàâêôãõüçñöÁÉÍÓÚÀÂÊÔÃÕÜÇÑÖ][a-z\\'áéíóúàâêôãõüçñöÁÉÍÓÚÀÂÊÔÃÕÜÇÑÖ\s-]+$/gi;
const isFullname = function (name, nameCount) {
  if (nameCount === void 0) {
    nameCount = 0;
  }
  if (!name) name = "";
  let hasSingleChars = false;
  const nameWithoutSpaces = name.trim();
  const splitedFullname = nameWithoutSpaces.split(/\s+/);
  const validSingleChairs = {
    e: true,
    E: true
  };
  const fullNameWithoutSingleChars = splitedFullname.reduce((acc, value, index, arr) => {
    if (value.length === 1 && !validSingleChairs[value]) hasSingleChars = true;
    if (index === 0 || index === arr.length - 1 || value.length > 1) {
      acc.push(value);
    }
    return acc;
  }, []).join(" ");
  const hasNameLimitation = nameCount ? splitedFullname.length === nameCount : splitedFullname.length > 1;
  const hasDeniedPrefix = !!fullNameWithoutSingleChars.match(DENIED_NAMES_PREFIXES);
  const isAllLettersValid = !!fullNameWithoutSingleChars.match(VALID_LETTERS);
  const isValidFullName = hasNameLimitation && !hasDeniedPrefix && isAllLettersValid && !hasSingleChars;
  return isValidFullName;
};
module.exports = isFullname;